if (!customElements.get('hs-shipping-offer')) {
  customElements.define('hs-shipping-offer', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-copy-code]');
      if (!button || this.copyHandler || !navigator.clipboard?.writeText) return;

      button.hidden = false;
      this.copyHandler = async () => {
        const label = button.querySelector('[data-copy-label]');
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          label.textContent = button.dataset.copySuccess;
          status.textContent = button.dataset.copyStatusSuccess;
        } catch {
          label.textContent = 'HEAVENSHIP';
          status.textContent = button.dataset.copyStatusFallback;
        }
      };
      button.addEventListener('click', this.copyHandler);
    }

    disconnectedCallback() {
      this.querySelector('[data-copy-code]')?.removeEventListener('click', this.copyHandler);
      this.copyHandler = null;
    }
  });
}
